<template>
	<div style="max-width: 1000px;padding: 50px 0 0 0;margin: auto;">
		<form @submit.prevent="submit">
			<loading :active="loading"
					 :can-cancel="false"
					 loader="dots"
					 color="#2292ef"
					 :is-full-page="true"></loading>
			<h3 class="mt-5 mb-5 ml-3 text-dark">{{text.create_your_profile}}</h3>
			<div class="card mt-5 mb-5">
				<div class="card-header cart-complete-skill">
					<div class="m-5">{{text.give_us_some_information_about_yourself}}</div>
				</div>
				<div class="card-body pl-5">
					<div class="row">
						<div class="d-flex flex-column justify-content-center p-5 m-2">
							<img id="preview-logo" class="m-auto rounded-circle" width="200" height="200"
								 src="/assets/images/Logo-Avatar.png">
							<button type="button" class="mt-5 ps-btn btn-sm btn-avatar" data-toggle="modal"
									data-target="#LogoModal">
								{{word.add_your_logo}}
							</button>
						</div>
					</div>
					<hr>
					<div class="row">
						<div class="col-10 ml-2">

							<div class="form-group skill-formdata">
								<label for="first_name">{{word.first_name}}
									<small v-if="errors && errors.first_name" class="form-text text-danger">
										{{errors.first_name[0]}}
									</small>
								</label>
								<input type="text" class="form-control"
									   id="first_name" name="first_name"
									   v-model="fields.first_name" :placeholder="word.first_name">

							</div>

							<div class="form-group skill-formdata">
								<label for="last_name">{{word.last_name}}
									<small v-if="errors && errors.last_name" class="form-text text-danger">
										{{errors.last_name[0]}}
									</small>
								</label>
								<input type="text" class="form-control"
									   id="last_name" name="last_name"
									   v-model="fields.last_name" :placeholder="word.last_name">

							</div>
							<div class="form-group skill-formdata">
								<label for="company_name">{{word.business}}
									<small v-if="errors && errors.company_name" class="form-text text-danger">
										{{errors.company_name[0]}}
									</small>
								</label>
								<input type="text" class="form-control"
									   id="company_name" v-model="fields.company_name" name="company_name"
									   :placeholder="word.company">

							</div>
							<div class="form-group">
								<label>Select your category</label>
								<multiselect @select="getSubCategories" v-model="fields.category" :options="categories"
											 :custom-label="categories.title"
											 placeholder="Type for search" label="title" track-by="title"></multiselect>
								<small v-if="errors && errors.category" class="form-text text-danger">
									{{errors.category[0]}}
								</small>
							</div>

							<div class="form-group">
								<label>{{word.suburb}}
									<small v-if="errors && errors.suburb_id" class="form-text text-danger">
										{{errors.suburb_id[0]}}
									</small>
								</label>
								<suburb v-model="fields.suburb"></suburb>

							</div>


							<div class="form-group skill-formdata">
								<label for="address">{{word.address}}
									<small v-if="errors && errors.address" class="form-text text-danger">
										{{errors.address[0]}}
									</small>
								</label>
								<input type="text" class="form-control"
									   id="address" name="address"
									   v-model="fields.address" :placeholder="word.address">

							</div>

							<div class="form-group skill-formdata">
								<label for="about_us">{{word.about_us }}
									<small v-if="errors && errors.about_us" class="form-text text-danger">
										{{errors.about_us[0]}}
									</small>
								</label>
								<textarea rows="10" class="form-control"
										  id="about_us" name="about_us"
										  v-model="fields.about_us">

								</textarea>

							</div>


						</div>
					</div>
				</div>
				<div class="card-footer">
					<button type="submit" class="ps-btn m-5">{{word.save_and_next}}</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect';
	import Suburb from './../../Suburb.vue';
	import Loading from 'vue-loading-overlay';
	import 'vue-loading-overlay/dist/vue-loading.css';

	export default {
		components: {
			Multiselect,
			Suburb, Loading
		},
		props: [
			'data'
		],
		data() {
			return {
				loading: false,
				data_: {},
				user: {},
				vars: {},
				categories: [],
				url: '',
				redirect: '',
				errors: {},
				fields: {},
				selected_sub_categories: null,
				word: null,
				text: null,
				isLoading: false
			}
		},
		created() {
			let data = JSON.parse(this.data);
			this.data_ = data;
			this.word = data.w;
			this.text = data.t;
			this.vars = data.vars;
			this.user = data.user;
			this.url = data.url;
			this.categories = data.categories;
			this.redirect = data.redirect;
			this.fields.first_name = this.user.first_name;
			this.fields.last_name = this.user.last_name;
			this.fields.phone_number = this.user.phone_number;
			this.fields.preferred_start_date = "Select a date";
			// console.log(data.get_states_url);
		},
		methods: {
			submit: function () {
				this.loading = true;
				this.$Progress.start();
				if (this.fields.suburb) {
					this.fields.suburb_id = this.fields.suburb.id;
				}
				if (this.fields.category) {
					this.fields.category_id = this.fields.category.id;
				}
				let self = this;
				axios({
					method: "post",
					url: self.url + "?_method=post",
					data: self.fields
				})
					.then(function (response) {
						self.loading = false;
						self.$Progress.finish();
						if (response.data.ok) {
							location.replace(self.redirect);
						} else {
							//something is wrong
						}
					})
					.catch(function (err) {
						self.loading = false;
						self.$Progress.fail();
						self.errors = err.response.data.errors;
					});
			},

			getSubcategories: function (category) {
				this.isLoading = true;
				this.sub_categories = [];
				this.selected_sub_categories = null;
				this.$Progress.start();
				let self = this;
				let fields = {
					category_id: category.id
				};

				axios({
					method: "post",
					url: "/category/get/sub/categories?_method=post",
					data: fields
				})
					.then(function (response) {
						self.isLoading = false;
						self.$Progress.finish();
						self.sub_categories = response.data.data;
						console.log(response.data);
						//location.replace(self.redirect);
					})
					.catch(function (err) {
						self.$Progress.fail();
						self.errors = err.response.data.errors;
					});
			},
			removeMessages: function () {
				this.errors = {};
			}

		}

	}
</script>
